import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FaSearch,
  FaMapMarkerAlt,
  FaPhone,
  FaUserMd,
} from "react-icons/fa";
import Navbar, { navbarHeight } from "../components/Navbar";
import Fotter from "../components/Fotter";

const doctors = [
  {
    name: "Dr. Aayush Sharma",
    type: "General Physician",
    city: "Indore",
    state: "Madhya Pradesh",
    image: "doc.jpg",
    clinicAddress: "Girraj MedicoMart Clinic",
    personalAddress: "Krishna Vihar",
    contact: "+91 9876543210",
  },
  {
    name: "Dr. Sneha Kapoor",
    type: "Dermatologist",
    city: "Gwalior",
    state: "Madhya Pradesh",
    image: "doc1.jpg",
    clinicAddress: "SkinGlow Clinic",
    personalAddress: "Rosewood Apartments",
    contact: "+91 9988776655",
  },
  {
    name: "Dr. Arjun Mehta",
    type: "Orthopedic Surgeon",
    city: "Bhopal",
    state: "Madhya Pradesh",
    image: "doc2.jpg",
    clinicAddress: "OrthoCare Hospital",
    personalAddress: "Green Valley",
    contact: "+91 9123456789",
  },
  {
    name: "Dr. Riya Singh",
    type: "Dentist",
    city: "Indore",
    state: "Madhya Pradesh",
    image: "doc3.jpg",
    clinicAddress: "WhiteSmile Clinic",
    personalAddress: "Shanti Nagar",
    contact: "+91 9812345678",
  },
];

const categories = ["All", ...new Set(doctors.map((d) => d.type))];
const cities = ["All", ...new Set(doctors.map((d) => d.city))];
const states = ["All", ...new Set(doctors.map((d) => d.state))];

const DoctorCard = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const [activeState, setActiveState] = useState("All");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filteredDoctors = doctors.filter((doc) => {
    const matchesCategory =
      activeCategory === "All" || doc.type === activeCategory;
    const matchesCity = activeCity === "All" || doc.city === activeCity;
    const matchesState = activeState === "All" || doc.state === activeState;

    const matchesSearch =
      doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.type.toLowerCase().includes(searchTerm.toLowerCase());

    return (
      matchesCategory &&
      matchesCity &&
      matchesState &&
      matchesSearch
    );
  });

  const FilterSection = ({ title, items, active, setter }) => (
    <>
      <h4
        style={{
          color: "#15803d",
          marginBottom: "12px",
          fontSize: "15px",
          fontWeight: "700",
        }}
      >
        {title}
      </h4>

      {items.map((item) => (
        <div
          key={item}
          onClick={() => setter(item)}
          style={{
            padding: "10px",
            marginBottom: "8px",
            borderRadius: "10px",
            cursor: "pointer",
            background: active === item ? "#16a34a" : "#fff",
            color: active === item ? "#fff" : "#333",
            fontWeight: "600",
            fontSize: "14px",
            transition: "0.3s",
            boxShadow:
              active === item
                ? "0 4px 12px rgba(22,163,74,0.25)"
                : "0 2px 6px rgba(0,0,0,0.05)",
          }}
        >
          {item}
        </div>
      ))}
    </>
  );

  return (
    <>
      <Navbar />

      <div
        style={{
          paddingTop: navbarHeight,
          minHeight: "100vh",
          background: "#f8fafc",
        }}
      >
        {/* Search */}
        <div
          style={{
            maxWidth: "1200px",
            margin: "12px auto",
            padding: "0 18px",
          }}
        >
          <div style={{ position: "relative" }}>
            <input
              type="text"
              placeholder="Search doctors..."
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
              style={{
                width: "100%",
                padding: "14px 45px 14px 18px",
                borderRadius: "14px",
                border: "1px solid #d1d5db",
                outline: "none",
                fontSize: "15px",
              }}
            />

            <FaSearch
              style={{
                position: "absolute",
                right: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#16a34a",
              }}
            />
          </div>
        </div>

        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "18px",
            padding: "0 18px 30px",
          }}
        >
          {/* Sidebar */}
          <div
            style={{
              width: isMobile ? "100%" : "250px",
              background: "#fff",
              padding: "18px",
              borderRadius: "16px",
              height: "fit-content",
              boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
              position: isMobile ? "relative" : "sticky",
              top: "90px",
            }}
          >
            <FilterSection
              title="Specialization"
              items={categories}
              active={activeCategory}
              setter={setActiveCategory}
            />

            <FilterSection
              title="City"
              items={cities}
              active={activeCity}
              setter={setActiveCity}
            />

            <FilterSection
              title="State"
              items={states}
              active={activeState}
              setter={setActiveState}
            />
          </div>

          {/* Cards */}
          <div
            style={{
              flex: 1,
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit,minmax(250px,1fr))",
              gap: "18px",
            }}
          >
            {filteredDoctors.map((doctor, index) => (
              <motion.div
                key={index}
                whileHover={{ y: -6 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{
                  background: "#fff",
                  borderRadius: "18px",
                  padding: "20px",
                  boxShadow:
                    "0 10px 25px rgba(0,0,0,0.07)",
                  textAlign: "center",
                }}
              >
                <img
                  src={doctor.image}
                  alt={doctor.name}
                  style={{
                    width: "90px",
                    height: "90px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "4px solid #dcfce7",
                    marginBottom: "12px",
                  }}
                />

                <h3
                  style={{
                    marginBottom: "6px",
                    fontSize: "18px",
                  }}
                >
                  {doctor.name}
                </h3>

                <p
                  style={{
                    color: "#16a34a",
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  <FaUserMd /> {doctor.type}
                </p>

                <p
                  style={{
                    fontSize: "13px",
                    color: "#64748b",
                    margin: "10px 0",
                  }}
                >
                  <FaMapMarkerAlt /> {doctor.city},{" "}
                  {doctor.state}
                </p>

                <p
                  style={{
                    fontSize: "13px",
                    color: "#64748b",
                  }}
                >
                  {doctor.clinicAddress}
                </p>

                <p
                  style={{
                    color: "#2563eb",
                    fontWeight: "700",
                    marginTop: "8px",
                    fontSize: "14px",
                  }}
                >
                  <FaPhone /> {doctor.contact}
                </p>

                <motion.a
                  whileTap={{ scale: 0.95 }}
                  href="/appointment"
                  style={{
                    marginTop: "14px",
                    display: "inline-block",
                    background:
                      "linear-gradient(135deg,#16a34a,#22c55e)",
                    color: "#fff",
                    padding: "11px 20px",
                    borderRadius: "30px",
                    textDecoration: "none",
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  Book Appointment
                </motion.a>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
};

export default DoctorCard;